import React from 'react';
import Svg, { Mask, Path, Rect, Circle, ClipPath, G, Defs } from 'react-native-svg';

export function CropFallBack({ width, height, borderColor }) {
  return (
    <>
      <Svg
        width={width}
        height={height}
        viewBox="0 0 43 42"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <Circle cx="21.5" cy="21" r="20.75" stroke={borderColor} strokeWidth="0.5" />
        <G clipPath="url(#clip0_1648_15866)">
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.9946 32.9996C11.8821 32.9996 11.7837 32.9012 11.7837 32.7747V20.8661C11.7837 20.7395 11.8821 20.6411 11.9946 20.6411C12.1211 20.6411 12.2195 20.7395 12.2195 20.8661V32.7747C12.2195 32.9012 12.1211 32.9996 11.9946 32.9996Z"
            fill="#E4E4E4"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.9947 21.0771C11.9385 21.0771 11.8822 21.049 11.8401 21.0068C11.2777 20.4444 10.9824 19.6992 10.9824 18.8978C10.9824 18.1105 11.2777 17.3512 11.8401 16.7889C11.9244 16.7045 12.065 16.7045 12.1494 16.7889C12.7118 17.3512 13.0211 18.1105 13.0211 18.8978C13.0211 19.6992 12.7118 20.4444 12.1494 21.0068C12.1072 21.049 12.051 21.0771 11.9947 21.0771Z"
            fill="#BCBCBC"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.9946 23.65C11.9383 23.65 11.8821 23.6218 11.8399 23.5937C11.7978 23.5515 11.7837 23.4953 11.7837 23.4391C11.7837 22.6377 12.093 21.8925 12.6554 21.3301C13.2178 20.7677 13.963 20.4584 14.7644 20.4443C14.8206 20.4443 14.8768 20.4725 14.919 20.5146C14.9612 20.5568 14.9753 20.6131 14.9753 20.6693C14.9753 21.4566 14.6659 22.2159 14.1036 22.7783C13.5412 23.3406 12.796 23.65 11.9946 23.65Z"
            fill="#BCBCBC"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.9948 23.65C11.2075 23.65 10.4483 23.3406 9.88586 22.7783C9.32347 22.2159 9.01416 21.4566 9.01416 20.6693C9.01416 20.6131 9.02822 20.5568 9.0704 20.5146C9.11258 20.4725 9.16882 20.4443 9.22506 20.4443C10.0265 20.4584 10.7716 20.7677 11.334 21.3301C11.8823 21.8784 12.2057 22.6236 12.2198 23.3969V23.4391C12.2198 23.5515 12.1214 23.65 11.9948 23.65Z"
            fill="#BCBCBC"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.9946 26.5323C11.9383 26.5323 11.8821 26.5042 11.8399 26.462C11.7978 26.4198 11.7837 26.3636 11.7837 26.3073C11.7837 25.52 12.093 24.7748 12.6554 24.2124C13.2178 23.65 13.963 23.3267 14.7644 23.3267C14.8206 23.3267 14.8768 23.3548 14.919 23.397C14.9612 23.4391 14.9753 23.4954 14.9753 23.5516C14.9753 24.339 14.6659 25.0841 14.1036 25.6465C13.5412 26.2089 12.796 26.5323 11.9946 26.5323Z"
            fill="#BCBCBC"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.9948 26.5323C11.2075 26.5323 10.4483 26.2089 9.88586 25.6465C9.32347 25.0841 9.01416 24.339 9.01416 23.5516C9.01416 23.4954 9.02822 23.4391 9.0704 23.397C9.11258 23.3548 9.16882 23.3267 9.22506 23.3267C10.0265 23.3267 10.7716 23.65 11.334 24.2124C11.8823 24.7608 12.2057 25.4919 12.2198 26.2792V26.3073C12.2198 26.4339 12.1214 26.5323 11.9948 26.5323Z"
            fill="#BCBCBC"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.9946 29.4146C11.9383 29.4146 11.8821 29.3865 11.8399 29.3443C11.7978 29.3021 11.7837 29.2459 11.7837 29.1897C11.7837 28.4023 12.093 27.6431 12.6554 27.0807C13.2178 26.5183 13.963 26.209 14.7644 26.209C14.8206 26.209 14.8768 26.2371 14.919 26.2652C14.9612 26.3074 14.9753 26.3636 14.9753 26.4199C14.9753 27.2213 14.6659 27.9665 14.1036 28.5288C13.5412 29.0912 12.796 29.4005 11.9946 29.4146Z"
            fill="#BCBCBC"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.9948 29.4146C11.2075 29.4005 10.4483 29.0912 9.88586 28.5288C9.32347 27.9665 9.01416 27.2213 9.01416 26.4199C9.01416 26.3636 9.02822 26.3074 9.0704 26.2652C9.11258 26.2371 9.16882 26.209 9.22506 26.209C10.0265 26.209 10.7716 26.5183 11.334 27.0807C11.8823 27.6431 12.2057 28.3742 12.2198 29.1615V29.1897C12.2198 29.3162 12.1214 29.4146 11.9948 29.4146Z"
            fill="#BCBCBC"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M29.6399 32.9998C29.4993 32.9998 29.4009 32.8874 29.4009 32.7468V19.4041C29.4009 19.2635 29.4993 19.165 29.6399 19.165C29.7805 19.165 29.8789 19.2635 29.8789 19.4041V32.7468C29.8789 32.8874 29.7805 32.9998 29.6399 32.9998Z"
            fill="#E4E4E4"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M29.6398 19.6431C29.5695 19.6431 29.5133 19.615 29.4711 19.5728C28.8384 18.9401 28.501 18.0965 28.501 17.2108C28.501 16.3109 28.8384 15.4814 29.4711 14.8487C29.5555 14.7503 29.7242 14.7503 29.8085 14.8487C30.4412 15.4814 30.7787 16.3109 30.7787 17.2108C30.7787 18.0965 30.4412 18.9401 29.8085 19.5728C29.7664 19.615 29.7101 19.6431 29.6398 19.6431Z"
            fill="#BCBCBC"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M29.6399 22.5254C29.5696 22.5254 29.5134 22.4973 29.4712 22.4551C29.429 22.4129 29.4009 22.3567 29.4009 22.2864C29.4009 21.4006 29.7524 20.5571 30.3851 19.9244C31.0178 19.2917 31.8473 18.9542 32.733 18.9402C32.8033 18.9402 32.8596 18.9683 32.9158 19.0105C32.958 19.0667 32.9861 19.123 32.9861 19.1933C32.9721 20.079 32.6346 20.9086 32.0019 21.5412C31.3692 22.1739 30.5257 22.5254 29.6399 22.5254Z"
            fill="#BCBCBC"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M29.6397 22.5254C28.7539 22.5254 27.9103 22.1739 27.2776 21.5412C26.645 20.9086 26.3075 20.079 26.2935 19.1933C26.2935 19.123 26.3216 19.0667 26.3638 19.0105C26.4059 18.9683 26.4762 18.9402 26.5325 18.9402H26.5465C27.4323 18.9542 28.2618 19.2917 28.8945 19.9244C29.5131 20.543 29.8646 21.3725 29.8787 22.2442V22.2864C29.8787 22.427 29.7803 22.5254 29.6397 22.5254Z"
            fill="#BCBCBC"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M29.6399 25.759C29.5696 25.759 29.5134 25.7309 29.4712 25.6887C29.429 25.6324 29.4009 25.5762 29.4009 25.5059C29.4009 24.6201 29.7524 23.7766 30.3851 23.1579C31.0178 22.5252 31.8473 22.1737 32.733 22.1737C32.8033 22.1597 32.8596 22.1878 32.9158 22.244C32.958 22.2862 32.9861 22.3425 32.9861 22.4128C32.9721 23.2985 32.6346 24.1421 32.0019 24.7748C31.3692 25.3934 30.5257 25.7449 29.6399 25.759Z"
            fill="#BCBCBC"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M29.6397 25.7591C28.7539 25.745 27.9103 25.3935 27.2776 24.7749C26.645 24.1422 26.3075 23.2986 26.2935 22.4128C26.2935 22.3425 26.3216 22.2863 26.3638 22.2441C26.4059 22.1879 26.4762 22.1738 26.5465 22.1738C27.4323 22.1738 28.2618 22.5253 28.8945 23.158C29.5131 23.7766 29.8646 24.5921 29.8787 25.4638V25.506C29.8787 25.6466 29.7803 25.7591 29.6397 25.7591Z"
            fill="#BCBCBC"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M29.6399 28.9788C29.5696 28.9788 29.5134 28.9507 29.4712 28.9085C29.429 28.8663 29.4009 28.796 29.4009 28.7398C29.4009 27.84 29.7524 27.0104 30.3851 26.3777C31.0178 25.745 31.8473 25.3936 32.733 25.3936C32.8033 25.3936 32.8596 25.4217 32.9158 25.4639C32.958 25.506 32.9861 25.5763 32.9861 25.6326C32.9721 26.5324 32.6346 27.3619 32.0019 27.9946C31.3692 28.6273 30.5257 28.9788 29.6399 28.9788Z"
            fill="#BCBCBC"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M29.6397 28.9788C28.7539 28.9788 27.9103 28.6273 27.2776 27.9946C26.645 27.3619 26.3075 26.5324 26.2935 25.6326C26.2935 25.5763 26.3216 25.506 26.3638 25.4639C26.4059 25.4217 26.4762 25.3936 26.5465 25.3936C27.4323 25.3936 28.2618 25.745 28.8945 26.3777C29.5131 26.9964 29.8646 27.8259 29.8787 28.6976V28.7398C29.8787 28.8663 29.7803 28.9788 29.6397 28.9788Z"
            fill="#BCBCBC"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20.8805 33C20.6977 33 20.5571 32.8453 20.5571 32.6766V15.0879C20.5571 14.9192 20.6977 14.7786 20.8805 14.7786C21.0633 14.7786 21.2039 14.9192 21.2039 15.0879V32.6766C21.2039 32.8453 21.0633 33 20.8805 33Z"
            fill="#E4E4E4"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20.8809 15.4112C20.7965 15.4112 20.7121 15.383 20.6559 15.3127C19.8264 14.4832 19.3765 13.3725 19.3765 12.2055C19.3765 11.0386 19.8264 9.92785 20.6559 9.09832C20.7684 8.97178 20.9933 8.97178 21.1058 9.09832C21.9353 9.92785 22.3853 11.0386 22.3853 12.2055C22.3853 13.3725 21.9353 14.4832 21.1058 15.3127C21.0496 15.383 20.9652 15.4112 20.8809 15.4112Z"
            fill="#BCBCBC"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20.8805 19.2072C20.7961 19.2072 20.7118 19.1791 20.6555 19.1229C20.5993 19.0526 20.5571 18.9823 20.5571 18.8979C20.5712 17.7169 21.0352 16.6202 21.8647 15.7907C22.6942 14.9612 23.7909 14.4972 24.9578 14.4832C25.0563 14.4832 25.1265 14.5253 25.1968 14.5816C25.2531 14.6378 25.2812 14.7222 25.2812 14.8065C25.2812 15.9875 24.8172 17.0842 23.9877 17.9137C23.1582 18.7433 22.0615 19.2072 20.8805 19.2072Z"
            fill="#BCBCBC"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20.8807 19.2072C19.6997 19.2072 18.603 18.7433 17.7735 17.9137C16.944 17.0842 16.48 15.9875 16.48 14.8065C16.48 14.7222 16.5081 14.6378 16.5784 14.5816C16.6346 14.5253 16.719 14.4832 16.8034 14.4832C17.9703 14.4972 19.081 14.9612 19.9106 15.7907C20.726 16.6062 21.1759 17.6888 21.2041 18.8417V18.8979C21.2041 19.0666 21.0635 19.2072 20.8807 19.2072Z"
            fill="#BCBCBC"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20.8805 23.4532C20.7961 23.4532 20.7118 23.4251 20.6555 23.3689C20.5993 23.2986 20.5571 23.2283 20.5571 23.1439C20.5712 21.9629 21.0352 20.8662 21.8647 20.0367C22.6942 19.2072 23.7909 18.7432 24.9578 18.7432C25.0563 18.7291 25.1265 18.7713 25.1968 18.8276C25.2531 18.8838 25.2812 18.9682 25.2812 19.0525C25.2812 20.2335 24.8172 21.3302 23.9877 22.1597C23.1582 22.9892 22.0615 23.4532 20.8805 23.4532Z"
            fill="#BCBCBC"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20.8807 23.4532C19.6997 23.4532 18.603 22.9892 17.7735 22.1597C16.944 21.3302 16.48 20.2335 16.48 19.0525C16.48 18.9682 16.5081 18.8838 16.5784 18.8276C16.6346 18.7713 16.719 18.7291 16.8034 18.7432C17.9703 18.7432 19.081 19.2072 19.9106 20.0367C20.726 20.8522 21.1759 21.9348 21.2041 23.0877V23.1439C21.2041 23.3126 21.0635 23.4532 20.8807 23.4532Z"
            fill="#BCBCBC"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20.8805 27.6993C20.7961 27.6993 20.7118 27.6712 20.6555 27.615C20.5993 27.5447 20.5571 27.4744 20.5571 27.39C20.5712 26.209 21.0352 25.1123 21.8647 24.2828C22.6942 23.4533 23.7909 22.9893 24.9578 22.9893C25.0563 22.9752 25.1265 23.0174 25.1968 23.0737C25.2531 23.1299 25.2812 23.2143 25.2812 23.2986C25.2812 24.4796 24.8172 25.5763 23.9877 26.4058C23.1582 27.2353 22.0615 27.6993 20.8805 27.6993Z"
            fill="#BCBCBC"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20.8807 27.6993C19.6997 27.6993 18.603 27.2353 17.7735 26.4058C16.944 25.5763 16.48 24.4796 16.48 23.2986C16.48 23.2143 16.5081 23.1299 16.5784 23.0737C16.6346 23.0174 16.719 22.9752 16.8034 22.9893C17.9703 22.9893 19.081 23.4533 19.9106 24.2828C20.726 25.0983 21.1759 26.1809 21.2041 27.3338V27.39C21.2041 27.5587 21.0635 27.6993 20.8807 27.6993Z"
            fill="#BCBCBC"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M31.4255 33H10.5608C10.3921 33 10.2515 32.8454 10.2515 32.6766C10.2515 32.4939 10.3921 32.3533 10.5608 32.3533H31.4255C31.6082 32.3533 31.7488 32.4939 31.7488 32.6766C31.7488 32.8454 31.6082 33 31.4255 33Z"
            fill="#BCBCBC"
          />
        </G>
        <Defs>
          <ClipPath id="clip0_1648_15866">
            <Rect width="24" height="24" fill="white" transform="translate(9 9)" />
          </ClipPath>
        </Defs>
      </Svg>
    </>
  );
}
